import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { UndoOutlined, PlayCircleOutlined } from '@ant-design/icons';

import { Button, Row, Col, Typography } from 'antd';
import {
  FormikTransfer,
  FormikDatePicker,
  FormikSelect,
  FormikButton
} from '../../Components/Formik';
import GdsRcptTrackingReportActions from '../../Stores/GdsRcptTrackingReport/Actions';

const { Text } = Typography;

class CriteriaForm extends React.PureComponent {
  constructor() {
    super();

    this.handleSearchDivision = this.handleSearchDivision.bind(this);
    this.handleSearchDeliveryPoint = this.handleSearchDeliveryPoint.bind(this);
    this.handleSearchDebtor = this.handleSearchDebtor.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleSearchDivision(form, value) {
    const { fetchDivisionOptions } = this.props;

    fetchDivisionOptions(value);
  }

  handleSearchDeliveryPoint(form, value) {
    const { fetchBizPartnerOptions } = this.props;

    fetchBizPartnerOptions(value);
  }

  handleSearchDebtor(form, value) {
    const { fetchDebtorOptions } = this.props;

    fetchDebtorOptions(value);
  }

  render() {
    const {
      intl,
      criteria,
      reportIsLoading,
      gdsRcptTracking,
      divisionOptions,
      divisionIsLoading,
      bizPartnerOptions,
      bizPartnerIsLoading,
      debtorOptions,
      debtorIsLoading
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={criteria}
        onSubmit={(values, formikBag) => {
          gdsRcptTracking(formikBag, values);
        }}
        validationSchema={Yup.object().shape({
          doc_date: Yup.date().min(
            new Date(1969, 12, 1),
            intl.formatMessage({ id: 'doc_date_is_required' })
          )
        })}
      >
        {({
          // values,
          // handleChange,
          // errors,
          // setFieldTouched,
          dirty,
          // touched,
          isSubmitting,
          // isValid,
          handleSubmit,
          handleReset
        }) => (
          <Form>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'start_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="start_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'end_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="end_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'division' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="division_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDivision}
                  notFoundContent={null}
                  loading={divisionIsLoading}
                  options={divisionOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'biz_partner' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="biz_partner_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDeliveryPoint}
                  notFoundContent={null}
                  loading={bizPartnerIsLoading}
                  options={bizPartnerOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'principal' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="debtor_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDebtor}
                  notFoundContent={null}
                  loading={debtorIsLoading}
                  options={debtorOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={24}>
                <Field
                  name="columns"
                  component={FormikTransfer}
                  intl={intl}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[0, 16]}>
              <Col span={24}>
                <Button
                  disabled={!dirty}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleReset}
                  icon={<UndoOutlined />}
                  type="primary"
                >
                  {intl.formatMessage({ id: 'reset' })}
                </Button>
                <Field
                  name="submit_action"
                  value="run_report"
                  component={FormikButton}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleSubmit}
                  label={intl.formatMessage({
                    id: 'run_report'
                  })}
                  icon={<PlayCircleOutlined />}
                  type="primary"
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    );
  }
}

CriteriaForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  // eslint-disable-next-line react/forbid-prop-types
  criteria: PropTypes.object,
  reportIsLoading: PropTypes.bool,
  gdsRcptTracking: PropTypes.func,
  fetchDivisionOptions: PropTypes.func,
  fetchBizPartnerOptions: PropTypes.func,
  fetchDebtorOptions: PropTypes.func,

  divisionOptions: PropTypes.arrayOf(PropTypes.object),
  divisionIsLoading: PropTypes.bool,

  bizPartnerOptions: PropTypes.arrayOf(PropTypes.object),
  bizPartnerIsLoading: PropTypes.bool,

  debtorOptions: PropTypes.arrayOf(PropTypes.object),
  debtorIsLoading: PropTypes.bool
};

CriteriaForm.defaultProps = {
  intl: {},

  criteria: {},
  reportIsLoading: false,
  gdsRcptTracking() {},
  fetchDivisionOptions() {},
  fetchBizPartnerOptions() {},
  fetchDebtorOptions() {},

  divisionOptions: [],
  divisionIsLoading: false,

  bizPartnerOptions: [],
  bizPartnerIsLoading: false,

  debtorOptions: [],
  debtorIsLoading: false
};

const mapStateToProps = state => ({
  timestamp: state.gdsRcptTrackingReport.timestamp,
  criteria: state.gdsRcptTrackingReport.criteria,

  reportIsLoading: state.gdsRcptTrackingReport.reportIsLoading,

  divisionOptions: state.gdsRcptTrackingReport.divisionOptions,
  divisionIsLoading: state.gdsRcptTrackingReport.divisionIsLoading,

  bizPartnerOptions: state.gdsRcptTrackingReport.bizPartnerOptions,
  bizPartnerIsLoading: state.gdsRcptTrackingReport.bizPartnerIsLoading,

  debtorOptions: state.gdsRcptTrackingReport.debtorOptions,
  debtorIsLoading: state.gdsRcptTrackingReport.debtorIsLoading
});

const mapDispatchToProps = dispatch => ({
  gdsRcptTracking: (formikBag, criteria) =>
    dispatch(
      GdsRcptTrackingReportActions.gdsRcptTrackingReportGdsRcptTracking(formikBag, criteria)
    ),

  fetchDivisionOptions: search =>
    dispatch(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDivisionOptions(search)),
  fetchBizPartnerOptions: search =>
    dispatch(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchBizPartnerOptions(search)),
  fetchDebtorOptions: search =>
    dispatch(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDebtorOptions(search))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CriteriaForm));
